import * as React from 'react';
import { withI18n } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Link, RouteComponentProps } from 'react-router-dom';
import queryString from 'query-string';
import i18nProps from '../helpers/i18n';

interface Props extends RouteComponentProps, i18nProps {

}

const PaymentThankYou: React.FC<Props> = ({ location, t }) => {
  const params = queryString.parse(location.search);
  const backLink = (() => {
    if (params.recent) {
      return <Link to={params.recent as string}>{t('トップページに戻り、お買い物を続ける')}</Link>;
    } else {
      return <Link to='/'>{t('トップページに戻り、お買い物を続ける')}</Link>;
    }
  })();
  return (
    <section style={{ textAlign: 'center' }}>
      <Helmet>
        <title>{t('THANK YOU!')} | Japanese Cuisine.com</title>
      </Helmet>

      <h1>{t('THANK YOU!')}</h1>

      <p>
        {t('ご注文ありがとうございます。')}<br/>
        {t('ご注文の確認メールを送信いたしましたのでご確認ください。')}
      </p>
      <p>
        {backLink}
      </p>
    </section>
  );
};

export default withI18n()(PaymentThankYou);